export const COUPON_BG_DEFAULT = {
  'MX': 'https://img0.didiglobal.com/static/gstar/img/JGeft8mthg1617038605094.png',
  'BR': 'https://img0.didiglobal.com/static/gstar/img/zQnJLm9UxX1617038604416.png',
  'JP': 'https://img0.didiglobal.com/static/gstar/img/WMxaspjKoX1617038604240.png',
  'CR': 'https://img0.didiglobal.com/static/gstar/img/JGeft8mthg1617038605094.png',
  'CO': 'https://img0.didiglobal.com/static/gstar/img/JGeft8mthg1617038605094.png',
  'DO': 'https://img0.didiglobal.com/static/gstar/img/JGeft8mthg1617038605094.png',
  'CL': 'https://img0.didiglobal.com/static/gstar/img/JGeft8mthg1617038605094.png'
}
